import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { ConstantContactContact } from '../constant-contact-contact';
import { ConstantContactContactPostRequest } from '../constant-contact-contact-post-request';
import { ConstantContactContactPutRequest } from '../constant-contact-contact-put-request';
import { ConstantContactCustomField } from '../constant-contact-custom-field';
import { ConstantContactEmailAddressPost } from '../constant-contact-email-address-post';
import { ConstantContactList } from '../constant-contact-list';
import { PermissionToSend } from '../constant-contact-permission-to-send';
import { ConstantContactStreetAddress } from '../constant-contact-street-address';
import { HttpService } from '../service/http.service';
import { ToastMessageService } from '../toast-message.service';
import { BookingService } from './booking.service';
import { ConstantContactStreetAddressPut } from '../constant-contact-street-address-put';

@Injectable({
  providedIn: 'root'
})
export class ConstantContactService {

    //Constant Contact booleans
    displayConstantContactDialog = false;
    isUnsubscribedToConstantContact = false;
    isCreatingConstantContactContact = false;
    listBoxDisabled = false;
    sendingConstantContact = false;
  
    //Constant Contact related
    contactLists: ConstantContactList[] = [];
    selectedConstantContactList!: ConstantContactList;
    targetList: ConstantContactList[] = [];
    selectedConstantContactContact!: ConstantContactContact | null;
    constantContactPostRequest!: ConstantContactContactPostRequest;
    constantContactErrorMessage!: string | null;
    selectedContactList: any[] = [];

  constructor(
    private httpService: HttpService,
    private bookingService: BookingService,
    private toastService: ToastMessageService
  ) { }

  initConstantContactList(){
    this.httpService.getConstantContactLists().subscribe(res => {
      this.contactLists = res.lists.sort((a, b) => {
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        } else {
          return -1;
        }
      });
    });
  }


  //userd in edit-booking component
  activateConstantContactDialog() {
    this.displayConstantContactDialog = true;
    this.isUnsubscribedToConstantContact = false;
    this.constantContactErrorMessage = null;
    if(this.contactLists.length == 0){
      this.httpService.getConstantContactLists().subscribe(res => {
        this.contactLists = res.lists.sort((a, b) => {
          if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return 1;
          } else {
            return -1;
          }
        });
        this.configTargetListWithEmail();
      });
    } else {
      this.configTargetListWithEmail();
    }
  }

  configTargetListWithEmail(){
    if (this.bookingService.booking.student.email) {
      this.httpService.getConstantContactContactListByEmail(this.bookingService.booking.student.email).subscribe(res => {
        console.log("contact found by email:" + this.bookingService.booking.student.email);
        //if email exist in Constant Contact
        if (res.contacts.length > 0) {
          this.isCreatingConstantContactContact = false;
          this.selectedConstantContactContact = res.contacts[0];
          console.log(res);
          if (this.selectedConstantContactContact.emailAddress.permissionToSend == PermissionToSend.UNSUBSCRIBED) {
            this.isUnsubscribedToConstantContact = true;
          } else if (this.selectedConstantContactContact.listMemberships && this.selectedConstantContactContact.listMemberships.length > 0) {
            this.initTargetList();
          }
        }
        //if email does not existe in Constant Contact, create one
        else {
          this.isCreatingConstantContactContact = true;
          this.constantContactPostRequest = this.getNewConstantContactContact();
          this.httpService.postConstantContactContactWithStudent(this.constantContactPostRequest, this.bookingService.booking.student.id!).subscribe(() => {
            this.isCreatingConstantContactContact = false;
            this.httpService.getConstantContactContactListByEmail(this.bookingService.booking.student.email).subscribe(res => {
              if (res.contacts.length > 0) {
                this.isCreatingConstantContactContact = false;
                this.selectedConstantContactContact = res.contacts[0];
                console.log(res);
                if (this.selectedConstantContactContact.emailAddress.permissionToSend == PermissionToSend.UNSUBSCRIBED) {
                  this.isUnsubscribedToConstantContact = true;
                } else if (this.selectedConstantContactContact.listMemberships && this.selectedConstantContactContact.listMemberships.length > 0) {
                  this.initTargetList();
                }
              }
            });
          }, error => {
            this.constantContactErrorMessage = "Failed to create contact on Constant Contact API. Please contact your system admin: " + error.error.message;
          })
        }
      }, error => {
        this.constantContactErrorMessage = "There is an error. Please contact your system admin: " + error.error.message;
      });
    } else {
      this.constantContactErrorMessage = "This student has no email. Please create one.";
      return;
    }
  }

  private initTargetList() {
    this.targetList = [];
    for (let listId of this.selectedConstantContactContact!.listMemberships) {
      for (let list of this.contactLists) {
        if (list.listId == listId) {
          this.targetList.push(list);
        }
      }
    }
  }

  private getNewConstantContactContact() {
    return new ConstantContactContactPostRequest(
      new ConstantContactEmailAddressPost(this.bookingService.booking.student.email, null),
      this.bookingService.booking.student.firstName,
      this.bookingService.booking.student.lastName,
      null,
      null,
      "Account",
      null,
      null,
      this.bookingService.booking.student.birthDay == null ? null : moment(this.bookingService.booking.student.birthDay).format("YYYY-MM-DD"),
      [],
      [],
      [new ConstantContactStreetAddressPut("home", null, this.bookingService.booking.student.city, null, this.bookingService.booking.student.postalCode, null)],
      [],
      []
    );
  }

  removeConstantContactList(selectedListId: ConstantContactList) {
    this.targetList = this.targetList.filter(val => val != selectedListId);
    this.updateConstantContact();
  }

  selectConstantContactList(value: ConstantContactList) {
    this.listBoxDisabled = true;
    for (let list of this.targetList) {
      if (list.listId == value.listId) {
        this.listBoxDisabled = false;
        return;
      }
    }
    this.targetList.push(value);
    if (this.isCreatingConstantContactContact) {
      this.addConstantContact();
    } else {
      this.updateConstantContact();
    }
    this.listBoxDisabled = false;
  }

  addConstantContact() {
    this.sendingConstantContact = true;
    if (this.bookingService.booking.student.birthDay) {
      this.constantContactPostRequest.customFields = [
        new ConstantContactCustomField("add5fa5c-d413-11eb-97c2-fa163e504c74", moment(this.bookingService.booking.student.birthDay).year().toString())
      ];
    }

    this.httpService.postConstantContactContact(this.constantContactPostRequest).subscribe(res => {
      this.displayConstantContactDialog = false;
      this.selectedConstantContactContact = null;
      this.sendingConstantContact = false;
      this.toastService.addSuccess("Success", "Contact is posted successfully");
    }, error => {
      this.sendingConstantContact = false;
      this.toastService.addError("Error", error.message);
    });
  }

  updateConstantContact() {
    let newMemberships = [];
    for (let list of this.targetList) {
      newMemberships.push(list.listId);
    }
    let putRequest = new ConstantContactContactPutRequest(
      this.selectedConstantContactContact!.emailAddress,
      this.selectedConstantContactContact!.firstName,
      this.selectedConstantContactContact!.lastName,
      this.selectedConstantContactContact!.companyName,
      this.selectedConstantContactContact!.birthdayMonth,
      this.selectedConstantContactContact!.birthdayDay,
      this.selectedConstantContactContact!.anniversary,
      "Account",
      this.selectedConstantContactContact!.customFields,
      this.selectedConstantContactContact!.phoneNumbers,
      this.selectedConstantContactContact!.streetAddresses,
      newMemberships,
      this.selectedConstantContactContact!.taggings
    );

    this.httpService.putConstantContactContact(putRequest, this.selectedConstantContactContact!.contactId).subscribe(res => {
      this.toastService.addSuccess("Success", "Contact updated");
    }, error => {
      this.toastService.addError("Error", error.message);
      console.error(error);
    });
  }
}
